import React, { useState, useEffect } from 'react';
import { Navigate, useSearchParams } from 'react-router-dom';
import { DISCUSS_TASK_PAGE_PATH } from '../lib/discussTaskLinks';
import Header from '../components/Header';
import Footer from '../components/Footer';
import ConsultantChatGate from '../components/ConsultantChatGate';
import OptimizeRoutineTasks from '../components/OptimizeRoutineTasks';
import AboutUsSection from '../components/AboutUsSection';
import TaskCTA from '../components/TaskCTA';
import RequestCalculationForm from '../components/RequestCalculationForm';
import HowItWorks from '../components/HowItWorks';
import InvoiceStepsSection from '../components/InvoiceStepsSection';
import NewsSection from '../components/NewsSection';
import SEOHead from '../components/SEOHead';
import { homeStructuredData } from '../data/siteSeo';
import { trackFreeConsultationClick } from '../lib/metrikaGoals';
import { PAGE_SEO } from '../data/pageSeo';

const HomePage = () => {
  const [isCalculationFormOpen, setIsCalculationFormOpen] = useState(false);
  const [searchParams] = useSearchParams();

  const seoData = PAGE_SEO['/'];

  useEffect(() => {
    const badge = document.getElementById('emergent-badge');
    if (badge) {
      badge.remove();
    }
  }, []);

  if (searchParams.get('discuss') === '1') {
    const next = new URLSearchParams(searchParams);
    next.delete('discuss');
    const query = next.toString();
    return <Navigate to={`${DISCUSS_TASK_PAGE_PATH}${query ? `?${query}` : ''}`} replace />;
  }

  const openCallbackForm = () => {
    trackFreeConsultationClick();
    setIsCalculationFormOpen(true);
  };

  return (
    <div className="min-h-screen flex flex-col">
      <SEOHead
        title={seoData.title}
        description={seoData.description}
        keywords={seoData.keywords}
        canonical={seoData.canonical}
        structuredData={homeStructuredData}
      />
      <Header />

      <main className="flex-1" style={{ paddingTop: '5rem' }}>
        <OptimizeRoutineTasks onConsultationClick={openCallbackForm} />

        <NewsSection />

        <HowItWorks onConsultationClick={openCallbackForm} />

        <InvoiceStepsSection />

        <AboutUsSection
          showTitle={false}
          showInfoCards={false}
          sectionHeading="Преимущества"
          hideAdvantagesHeading
        />

        <TaskCTA
          title="Обратный звонок"
          onCalculationClick={openCallbackForm}
          showRequestButton={false}
        />
      </main>

      <Footer />
      <ConsultantChatGate />
      <RequestCalculationForm
        open={isCalculationFormOpen}
        onOpenChange={setIsCalculationFormOpen}
        calculatorData={null}
      />
    </div>
  );
};

export default HomePage;
